


























import { Forbidden } from '@/api/responses/forbidden';
import { TaskApi } from '@/api/task';
import { TaskItem } from '@/shared/task-item';
import { User } from '@/shared/user';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const usersModule = namespace('users');
const taskApi = new TaskApi();

@Component
export default class AssignTaskDialog extends Vue {
    @usersModule.Getter('activeUsers') private users!: Array<User>;

    @Prop({ required: true }) private visible!: boolean;
    @Prop({ required: true }) private tasks!: Array<TaskItem>;

    private isVisible: boolean = this.visible;
    private isSaving: boolean = false;
    private selectedUsers: Array<User> = [];

    private get filteredUsers(): Array<User> {
        return this.tasks.every((task) => task!.partnerPracticeId === this.tasks[0].partnerPracticeId!)
            ? this.users.filter((user) => user.partnerPracticeId == null || user.partnerPracticeId === this.tasks[0].partnerPracticeId!)
            : this.users.filter((user) => user.partnerPracticeId == null);
    }

    @Watch('visible')
    public visibleChanged(visible: boolean) {
        this.isVisible = visible;
    }

    private async onSaveAsync(): Promise<void> {
        try {
            this.isSaving = true;

            for (const task of this.tasks) {
                await taskApi.assignTaskAsync(task.id!, this.selectedUsers.map((user) => user.id!));
            }

            this.$emit('ok', { ...this.tasks });
        } catch (e) {
            if (e instanceof Forbidden) {
                this.$router.push({ name: `forbidden` });
            } else if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: 'Could not assign tasks, please try again.', type: 'is-danger' });
            }
        }

        this.isSaving = false;
    }

    private onCancel(): void {
        this.$emit('cancel');
    }

    private fullName(user: User): string {
        return `${user.firstName!.trim()} ${user.lastName!.trim()}`.trim();
    }
}
